import script from "./PageOrganizationHouseTemplateModule.vue?vue&type=script&setup=true&lang=js"
export * from "./PageOrganizationHouseTemplateModule.vue?vue&type=script&setup=true&lang=js"

import "./PageOrganizationHouseTemplateModule.vue?vue&type=style&index=0&id=45eae264&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-45eae264"]])

export default __exports__